module.exports = __webpack_public_path__ + "media/images/front/materials/cuero-8cb064fb07a2712f9a06e97a6485bfb9.jpg";